// Adapted from https://github.com/rebassjs/rebass/blob/master/packages/space/src/index.js
import styled from 'styled-components';
import { space } from 'styled-system';
import { ChildrenWithClass } from '../tools/components';
const Space = styled(ChildrenWithClass) `
  &&&& {
    ${space}
  }
`;
export { Space };
//# sourceMappingURL=Space.js.map